export const PAYMENTS = [
  {
    label: "EFECTIVO",
    value: "EFECTIVO",
    id: 1
  },
  {
    label: "TRANSFERENCIA",
    value: "TRANSFERENCIA",
    id: 2
  },
]